import { useState, useEffect, useMemo, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Search, Filter, X, ChevronLeft, ChevronRight, Star, Heart, ShoppingBag, Eye, Check, Info, Calendar, Truck, Bookmark } from 'lucide-react';
import StoreOffersAPI, { StoreOffer, GownType, GownStyle, GownColor } from '../../api/StoreOffersAPI';
import CONFIG from '../../config/config';
import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton';
import { toastService } from '../../services/ToastService';

const MOCK_STORE_OFFERS: StoreOffer[] = [
  {
    id: 1,
    name: 'Luna',
    description: 'An elegant and timeless wedding dress that captures the essence of classic bridal beauty. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 6900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Luna_1.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Luna_2.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Luna_3.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Luna_4.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Luna_1.jpg',
    gownType: 'ballgown',
    gownStyle: 'classic',
    gownColor: 'white',
    size: 'M',
    available: true,
    quantity: 1,
    featured: true,
    onSale: true,
    salePrice: 3450,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    name: 'Magnolia',
    description: 'A stunning wedding dress with exquisite details and graceful elegance. Perfect for the bride who wants to make a statement. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 10600,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_1_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_2_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_3_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_4_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_5_.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Magnolia_1_.jpg',
    gownType: 'ballgown',
    gownStyle: 'romantic',
    gownColor: 'ivory',
    size: 'L',
    available: true,
    quantity: 1,
    featured: true,
    onSale: true,
    salePrice: 5300,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 3,
    name: 'Melody',
    description: 'A beautiful wedding dress that sings with elegance and sophistication. Designed to make you feel like the most beautiful version of yourself. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 9900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_1_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_2_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_3_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_4_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_5_.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_6_.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Melody_1_.jpg',
    gownType: 'a-line',
    gownStyle: 'romantic',
    gownColor: 'white',
    size: 'M',
    available: true,
    quantity: 1,
    featured: true,
    onSale: true,
    salePrice: 4950,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 4,
    name: 'Alice',
    description: 'A romantic and dreamy wedding dress that captures the magic of your special day. Perfect for the modern bride with classic taste. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 8900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice2.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice3.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice4.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice5.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Alice2.jpg',
    gownType: 'a-line',
    gownStyle: 'romantic',
    gownColor: 'ivory',
    size: 'M',
    available: true,
    quantity: 1,
    featured: false,
    onSale: true,
    salePrice: 4450,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 5,
    name: 'Blossom',
    description: 'A fresh and feminine wedding dress that blooms with beauty and grace. Perfect for the bride who wants to feel like a garden princess. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 7900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom_2.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom_3_.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom_4.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom_5.JPG',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blossom.JPG',
    gownType: 'a-line',
    gownStyle: 'romantic',
    gownColor: 'white',
    size: 'S',
    available: true,
    quantity: 1,
    featured: false,
    onSale: true,
    salePrice: 3950,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 6,
    name: 'Blake',
    description: 'A sophisticated and modern wedding dress with clean lines and elegant simplicity. Perfect for the contemporary bride. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 9800,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blake_2.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blake.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blake_3.JPG',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blake_4.JPG',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Blake_2.JPG',
    gownType: 'sheath',
    gownStyle: 'modern',
    gownColor: 'white',
    size: 'M',
    available: true,
    quantity: 1,
    featured: false,
    onSale: true,
    salePrice: 4900,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 7,
    name: 'Perla',
    description: 'A pearl-like wedding dress that radiates elegance and timeless beauty. Perfect for the bride who appreciates classic sophistication. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 8900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Perla.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Perla3.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Perla4.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Perla.jpg',
    gownType: 'mermaid',
    gownStyle: 'classic',
    gownColor: 'ivory',
    size: 'L',
    available: true,
    quantity: 1,
    featured: false,
    onSale: true,
    salePrice: 4450,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 8,
    name: 'Athena',
    description: 'A powerful and elegant wedding dress inspired by the goddess of wisdom. Perfect for the strong and sophisticated bride. This is an outlet sample model from previous years - a great opportunity to own this beautiful dress at an exceptional price.',
    price: 8900,
    currency: 'PLN',
    images: [
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_4.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_5.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_3.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_2.jpg',
      'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_1.jpg',
    ],
    featuredImage: 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/1/catalogues/Athena_4.jpg',
    gownType: 'ballgown',
    gownStyle: 'classic',
    gownColor: 'white',
    size: 'M',
    available: true,
    quantity: 1,
    featured: true,
    onSale: true,
    salePrice: 4450,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

const getGownTypeLabel = (type: GownType): string => {
  const labels: Record<GownType, string> = {
    'ballgown': 'Ballgown',
    'mermaid': 'Mermaid',
    'a-line': 'A-Line',
    'sheath': 'Sheath',
    'trumpet': 'Trumpet',
    'tea-length': 'Tea Length',
    'other': 'Other',
  };
  return labels[type] || type;
};

const getGownStyleLabel = (style: GownStyle): string => {
  const labels: Record<GownStyle, string> = {
    'classic': 'Classic',
    'modern': 'Modern',
    'vintage': 'Vintage',
    'boho': 'Boho',
    'romantic': 'Romantic',
    'minimalist': 'Minimalist',
  };
  return labels[style] || style;
};

const getGownColorLabel = (color: GownColor): string => {
  const labels: Record<GownColor, string> = {
    'white': 'White',
    'ivory': 'Ivory',
    'blush': 'Blush',
    'champagne': 'Champagne',
    'silver': 'Silver',
    'gold': 'Gold',
    'other': 'Other',
  };
  return labels[color] || color;
};

const BOOKMARKS_STORAGE_KEY = 'publicStoreBookmarks';

const PublicStorePage = () => {
  const { storeLink, dressId } = useParams<{ storeLink: string; dressId?: string }>();
  const navigate = useNavigate();
  const [offers, setOffers] = useState<StoreOffer[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isStoreEnabled, setIsStoreEnabled] = useState(false);
  const [storeName, setStoreName] = useState<string>('');
  const [headerImageUrl, setHeaderImageUrl] = useState<string>('https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/76ec0ec8-b75a-403b-adb9-3d609ef4d6cd/catalogues/Screenshot_2025-12-02_at_19.51.43.png');
  const [headerText, setHeaderText] = useState<string>('Discover our outlet collection of sample models from previous years - a great opportunity to find your dream dress at an exceptional price');
  const [showBookAppointmentButton, setShowBookAppointmentButton] = useState<boolean>(true);
  const [selectedOffer, setSelectedOffer] = useState<StoreOffer | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedGownType, setSelectedGownType] = useState<GownType | 'all'>('all');
  const [selectedGownStyle, setSelectedGownStyle] = useState<GownStyle | 'all'>('all');
  const [showFilters, setShowFilters] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState<Record<number, number>>({});
  const [bookmarkedDresses, setBookmarkedDresses] = useState<Set<number>>(new Set());
  const resultsCountRef = useRef<HTMLParagraphElement>(null);

  // Load bookmarks from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(BOOKMARKS_STORAGE_KEY);
      if (stored) {
        const bookmarks = JSON.parse(stored);
        setBookmarkedDresses(new Set(bookmarks));
      }
    } catch (error) {
      console.error('Error loading bookmarks:', error);
    }
  }, []);

  // Save bookmarks to localStorage
  const saveBookmarks = (bookmarks: Set<number>) => {
    try {
      localStorage.setItem(BOOKMARKS_STORAGE_KEY, JSON.stringify(Array.from(bookmarks)));
    } catch (error) {
      console.error('Error saving bookmarks:', error);
    }
  };

  // Toggle bookmark
  const toggleBookmark = (dressId: number) => {
    setBookmarkedDresses(prev => {
      const newBookmarks = new Set(prev);
      const wasBookmarked = newBookmarks.has(dressId);
      const dress = offers.find(o => o.id === dressId);
      const dressName = dress?.name || 'Dress';
      
      if (wasBookmarked) {
        newBookmarks.delete(dressId);
        toastService.showToast(`${dressName} removed from saved items`, 'success');
      } else {
        newBookmarks.add(dressId);
        toastService.showToast(`${dressName} saved for later`, 'success');
      }
      saveBookmarks(newBookmarks);
      return newBookmarks;
    });
  };

  useEffect(() => {
    const fetchStoreData = async () => {
      if (!storeLink) return;
      
      setIsLoading(true);
      
      // Only show content for "agnieszkaswiatly" store
      if (storeLink === 'agnieszkaswiatly') {
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        setOffers(MOCK_STORE_OFFERS);
        setIsStoreEnabled(true);
        setStoreName('Agnieszka Światły - Store');
        setHeaderText('Discover our outlet collection of sample models from previous years - a great opportunity to find your dream dress at an exceptional price');
        setIsLoading(false);
        return;
      }
      
      try {
        const response = await StoreOffersAPI.getPublicStore(storeLink);
        setOffers(response.data.offers || []);
        setIsStoreEnabled(response.data.enabled || false);
        setStoreName(response.data.storeName || '');
        setHeaderImageUrl(response.data.headerImageUrl || 'https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/76ec0ec8-b75a-403b-adb9-3d609ef4d6cd/catalogues/Screenshot_2025-12-02_at_19.51.43.png');
        setHeaderText(response.data.headerText || 'Discover our exquisite collection of wedding dresses');
        setShowBookAppointmentButton(response.data.showBookAppointmentButton !== false);
      } catch (error) {
        console.error('Error fetching store data:', error);
        // Only show mock data for "agnieszkaswiatly"
        if (storeLink === 'agnieszkaswiatly') {
          console.log('Using mock data as fallback');
          setOffers(MOCK_STORE_OFFERS);
          setIsStoreEnabled(true);
          setStoreName('Agnieszka Światły - Store');
          setHeaderImageUrl('https://resources-public-eateliers-com.s3.eu-west-1.amazonaws.com/76ec0ec8-b75a-403b-adb9-3d609ef4d6cd/catalogues/Screenshot_2025-12-02_at_19.51.43.png');
          setHeaderText('Discover our outlet collection of sample models from previous years - a great opportunity to find your dream dress at an exceptional price');
          setShowBookAppointmentButton(true);
        } else {
          setIsStoreEnabled(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchStoreData();
  }, [storeLink]);

  // Handle dress selection from URL or state
  useEffect(() => {
    if (dressId && offers.length > 0) {
      const dressIdNum = parseInt(dressId, 10);
      const dress = offers.find(o => o.id === dressIdNum);
      if (dress) {
        setSelectedOffer(dress);
        // Scroll to results count when loading from URL
        setTimeout(() => {
          if (resultsCountRef.current) {
            resultsCountRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 300);
      } else {
        // If dress not found, navigate back to store listing
        navigate(`/store/${storeLink}`, { replace: true });
      }
    } else if (!dressId && selectedOffer) {
      // If URL doesn't have dressId but we have selectedOffer, update URL
      if (selectedOffer.id) {
        navigate(`/store/${storeLink}/${selectedOffer.id}`, { replace: true });
      }
    }
  }, [dressId, offers, storeLink, navigate, selectedOffer]);

  // Scroll to results count when selectedOffer changes
  useEffect(() => {
    if (selectedOffer) {
      setTimeout(() => {
        if (resultsCountRef.current) {
          resultsCountRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    }
  }, [selectedOffer]);

  // Update URL when selecting a dress
  const handleSelectDress = (offer: StoreOffer) => {
    setSelectedOffer(offer);
    if (offer.id && storeLink) {
      navigate(`/store/${storeLink}/${offer.id}`);
    }
    // Scroll will be handled by the useEffect that watches selectedOffer
  };

  // Handle back navigation
  const handleBackToListing = () => {
    setSelectedOffer(null);
    if (storeLink) {
      navigate(`/store/${storeLink}`);
    }
  };

  const filteredOffers = useMemo(() => {
    return offers.filter(offer => {
      const matchesSearch = !searchQuery || 
        offer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        offer.description?.toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesType = selectedGownType === 'all' || offer.gownType === selectedGownType;
      const matchesStyle = selectedGownStyle === 'all' || offer.gownStyle === selectedGownStyle;
      
      return matchesSearch && matchesType && matchesStyle;
    });
  }, [offers, searchQuery, selectedGownType, selectedGownStyle]);

  const uniqueGownTypes = useMemo(() => {
    return Array.from(new Set(offers.map(o => o.gownType)));
  }, [offers]);

  const uniqueGownStyles = useMemo(() => {
    return Array.from(new Set(offers.map(o => o.gownStyle)));
  }, [offers]);

  const handleImageChange = (offerId: number, direction: 'next' | 'prev') => {
    const offer = offers.find(o => o.id === offerId);
    if (!offer || offer.images.length <= 1) return;

    const currentIndex = currentImageIndex[offerId] || 0;
    let newIndex: number;

    if (direction === 'next') {
      newIndex = (currentIndex + 1) % offer.images.length;
    } else {
      newIndex = currentIndex === 0 ? offer.images.length - 1 : currentIndex - 1;
    }

    setCurrentImageIndex(prev => ({ ...prev, [offerId]: newIndex }));
  };

  const getCurrentImage = (offer: StoreOffer): string => {
    const index = currentImageIndex[offer.id!] || 0;
    return offer.images[index] || offer.featuredImage || '';
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  // Only show content for "agnieszkaswiatly" store
  if (storeLink !== 'agnieszkaswiatly') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <ShoppingBag className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Store Unavailable</h1>
          <p className="text-gray-600">This store is currently not available. Please check back later.</p>
        </div>
      </div>
    );
  }

  if (!isStoreEnabled) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <ShoppingBag className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Store Unavailable</h1>
          <p className="text-gray-600">This store is currently not available. Please check back later.</p>
        </div>
      </div>
    );
  }

  if (offers.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <Heart className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">{storeName || 'Agnieszka Światły - Store'}</h1>
          <p className="text-gray-600">No offers available at the moment. Check back soon!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
      {/* Hero Section with Header Image */}
      <div className="relative h-[60vh] min-h-[400px] max-h-[600px] overflow-hidden bg-gradient-to-r from-primary-600 to-primary-800">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: headerImageUrl ? `url('${headerImageUrl}')` : undefined,
          }}
        >
        </div>
        {/* Lighter overlay so image shows through */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/20 to-black/30"></div>
        
        {/* Content Overlay */}
        <div className="relative h-full flex items-center justify-center">
          <div className="text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight text-white drop-shadow-lg">
              {storeName || 'Agnieszka Światły - Store'}
            </h1>
            {headerText && (
              <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto drop-shadow-md">
                {headerText}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Search and Filter Bar */}
      <div className="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row gap-4 items-center">
            {/* Search */}
            <div className="relative flex-1 w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <input
                type="text"
                placeholder="Search dresses..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
            </div>

            {/* Filter Toggle */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex-shrink-0"
            >
              <Filter className="h-5 w-5" />
              <span>Filters</span>
            </button>
          </div>

          {/* Filter Panel */}
          {showFilters && (
            <div className="mt-4 pt-4 border-t border-gray-200 transition-all duration-200">
              <div className="flex flex-wrap gap-4">
                {/* Gown Type Filter */}
                <div className="flex-1 min-w-[200px]">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Gown Type</label>
                  <select
                    value={selectedGownType}
                    onChange={(e) => setSelectedGownType(e.target.value as GownType | 'all')}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value="all">All Types</option>
                    {uniqueGownTypes.map(type => (
                      <option key={type} value={type}>{getGownTypeLabel(type)}</option>
                    ))}
                  </select>
                </div>

                {/* Gown Style Filter */}
                <div className="flex-1 min-w-[200px]">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Style</label>
                  <select
                    value={selectedGownStyle}
                    onChange={(e) => setSelectedGownStyle(e.target.value as GownStyle | 'all')}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                  >
                    <option value="all">All Styles</option>
                    {uniqueGownStyles.map(style => (
                      <option key={style} value={style}>{getGownStyleLabel(style)}</option>
                    ))}
                  </select>
                </div>

                {/* Clear Filters */}
                {(selectedGownType !== 'all' || selectedGownStyle !== 'all' || searchQuery) && (
                  <div className="flex items-end">
                    <button
                      onClick={() => {
                        setSelectedGownType('all');
                        setSelectedGownStyle('all');
                        setSearchQuery('');
                      }}
                      className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 flex items-center gap-2"
                    >
                      <X className="h-4 w-4" />
                      Clear filters
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Results Count */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <p ref={resultsCountRef} className="text-sm text-gray-600">
          Showing {filteredOffers.length} {filteredOffers.length === 1 ? 'dress' : 'dresses'}
          {filteredOffers.length !== offers.length && ` of ${offers.length}`}
        </p>
      </div>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        {!selectedOffer ? (
          /* Listing Content */
          <>
            {filteredOffers.length === 0 ? (
              <div className="text-center py-16">
                <Eye className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No dresses found</h3>
                <p className="text-gray-600">Try adjusting your search or filters</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredOffers.map((offer) => {
              const currentImage = getCurrentImage(offer);
              const hasMultipleImages = offer.images.length > 1;

              return (
                <div
                  key={offer.id}
                  className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer transform hover:-translate-y-1"
                  onClick={() => handleSelectDress(offer)}
                >
                  {/* Image Container */}
                  <div className="relative aspect-[3/4] bg-gray-100 overflow-hidden">
                    {currentImage ? (
                      <>
                        <img
                          src={currentImage}
                          alt={offer.name}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          onError={(e) => {
                            (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f3f4f6" width="400" height="400"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="20" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3ENo Image%3C/text%3E%3C/svg%3E';
                          }}
                        />
                        {hasMultipleImages && (
                          <>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleImageChange(offer.id!, 'prev');
                              }}
                              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <ChevronLeft className="h-5 w-5" />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleImageChange(offer.id!, 'next');
                              }}
                              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <ChevronRight className="h-5 w-5" />
                            </button>
                            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                              {offer.images.map((_, idx) => (
                                <div
                                  key={idx}
                                  className={`h-1.5 rounded-full transition-all ${
                                    (currentImageIndex[offer.id!] || 0) === idx
                                      ? 'bg-white w-4'
                                      : 'bg-white bg-opacity-50 w-1.5'
                                  }`}
                                />
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gray-200">
                        <Eye className="h-12 w-12 text-gray-400" />
                      </div>
                    )}

                    {/* Badges */}
                    <div className="absolute top-3 left-3 flex flex-col gap-2">
                      {offer.featured && (
                        <div className="bg-yellow-400 text-yellow-900 rounded-full p-1.5 shadow-lg flex-shrink-0 w-fit h-fit">
                          <Star className="h-4 w-4 fill-current" />
                        </div>
                      )}
                      {offer.onSale && (
                        <div className="bg-red-500 text-white px-2 py-1 rounded text-xs font-bold shadow-lg flex-shrink-0 w-fit">
                          SALE
                        </div>
                      )}
                    </div>

                    {/* Bookmark Button */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (offer.id) {
                          toggleBookmark(offer.id);
                        }
                      }}
                      className={`absolute top-3 right-3 rounded-full p-2 shadow-lg transition-all z-10 ${
                        bookmarkedDresses.has(offer.id!) 
                          ? 'bg-primary-500 hover:bg-primary-600 ring-2 ring-primary-400 ring-offset-2' 
                          : 'bg-white bg-opacity-90 hover:bg-opacity-100'
                      }`}
                      aria-label={bookmarkedDresses.has(offer.id!) ? 'Remove from bookmarks' : 'Add to bookmarks'}
                    >
                      <Bookmark 
                        className={`h-5 w-5 transition-all ${
                          bookmarkedDresses.has(offer.id!) 
                            ? 'fill-yellow-400 text-yellow-400 drop-shadow-sm' 
                            : 'text-gray-600 hover:text-primary-600'
                        }`} 
                      />
                    </button>

                    {!offer.available && (
                      <div className="absolute top-3 right-3 bg-gray-900 text-white px-3 py-1 rounded text-xs font-medium">
                        Unavailable
                      </div>
                    )}

                    {offer.images.length > 1 && (
                      <div className="absolute bottom-3 right-3 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                        {offer.images.length} photos
                      </div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="p-5">
                    <h3 className="font-semibold text-lg text-gray-900 mb-2 line-clamp-1">
                      {offer.name}
                    </h3>

                    {offer.description && (
                      <p className="text-sm text-gray-600 line-clamp-2 mb-3">
                        {offer.description}
                      </p>
                    )}

                    {/* Tags */}
                    <div className="flex flex-wrap gap-2 mb-3">
                      <span className="px-2 py-1 bg-primary-100 text-primary-700 rounded text-xs font-medium">
                        {getGownTypeLabel(offer.gownType)}
                      </span>
                      <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
                        {getGownStyleLabel(offer.gownStyle)}
                      </span>
                    </div>

                    {/* Price */}
                    <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                      <div>
                        {offer.onSale && offer.salePrice !== undefined ? (
                          <div className="flex items-center gap-2">
                            <span className="text-xl font-bold text-red-600">
                              {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[offer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || offer.currency}
                              {offer.salePrice.toLocaleString()}
                            </span>
                            <span className="text-sm text-gray-400 line-through">
                              {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[offer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || offer.currency}
                              {offer.price.toLocaleString()}
                            </span>
                          </div>
                        ) : (
                          <span className="text-xl font-bold text-gray-900">
                            {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[offer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || offer.currency}
                            {offer.price.toLocaleString()}
                          </span>
                        )}
                      </div>
                      {offer.size && (
                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                          Size {offer.size}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
              </div>
            )}
          </>
        ) : (
          /* Detail Content - E-commerce Product Page Layout */
          <div className="w-full bg-white">
            {/* Back Button */}
            <button
              onClick={handleBackToListing}
              className="mb-6 flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ChevronLeft className="h-5 w-5" />
              <span>Back to Collection</span>
            </button>

            {/* Product Layout - Two Columns */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              {/* Left Column - Images */}
              <div className="space-y-4">
                {/* Main Image */}
                <div className="relative aspect-square bg-gray-100 rounded-lg overflow-hidden">
                  {selectedOffer.images.length > 0 ? (
                    <img
                      src={selectedOffer.images[currentImageIndex[selectedOffer.id!] || 0] || selectedOffer.featuredImage || ''}
                      alt={selectedOffer.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f3f4f6" width="400" height="400"/%3E%3Ctext fill="%239ca3af" font-family="sans-serif" font-size="20" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3ENo Image%3C/text%3E%3C/svg%3E';
                      }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                      <ShoppingBag className="h-16 w-16 text-gray-400" />
                    </div>
                  )}
                  
                  {/* Bookmark Button on Image */}
                  {selectedOffer.id && (
                    <button
                      onClick={() => toggleBookmark(selectedOffer.id!)}
                      className={`absolute top-4 right-4 rounded-full p-3 shadow-lg transition-all z-10 ${
                        bookmarkedDresses.has(selectedOffer.id) 
                          ? 'bg-primary-500 hover:bg-primary-600 ring-2 ring-primary-400 ring-offset-2' 
                          : 'bg-white bg-opacity-90 hover:bg-opacity-100'
                      }`}
                      aria-label={bookmarkedDresses.has(selectedOffer.id) ? 'Remove from bookmarks' : 'Add to bookmarks'}
                    >
                      <Bookmark 
                        className={`h-6 w-6 transition-all ${
                          bookmarkedDresses.has(selectedOffer.id) 
                            ? 'fill-yellow-400 text-yellow-400 drop-shadow-sm' 
                            : 'text-gray-600 hover:text-primary-600'
                        }`} 
                      />
                    </button>
                  )}
                  
                  {/* Image Navigation */}
                  {selectedOffer.images.length > 1 && (
                    <>
                      <button
                        onClick={() => handleImageChange(selectedOffer.id!, 'prev')}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
                      >
                        <ChevronLeft className="h-5 w-5 text-gray-700" />
                      </button>
                      <button
                        onClick={() => handleImageChange(selectedOffer.id!, 'next')}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
                      >
                        <ChevronRight className="h-5 w-5 text-gray-700" />
                      </button>
                    </>
                  )}
                </div>

                {/* Thumbnail Gallery */}
                {selectedOffer.images.length > 1 && (
                  <div className="flex gap-2 overflow-x-auto pb-2">
                    {selectedOffer.images.map((img, idx) => (
                      <button
                        key={idx}
                        onClick={() => setCurrentImageIndex(prev => ({ ...prev, [selectedOffer.id!]: idx }))}
                        className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                          idx === (currentImageIndex[selectedOffer.id!] || 0)
                            ? 'border-primary-500 ring-2 ring-primary-200'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <img
                          src={img}
                          alt={`${selectedOffer.name} ${idx + 1}`}
                          className="w-full h-full object-cover"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Right Column - Product Details */}
              <div className="space-y-6">
                {/* Product Name */}
                <div>
                  <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                    {selectedOffer.name}
                  </h1>
                  {selectedOffer.featured && (
                    <div className="inline-flex items-center gap-1 text-yellow-600 mb-2">
                      <Star className="h-4 w-4 fill-current" />
                      <span className="text-sm font-medium">Featured</span>
                    </div>
                  )}
                </div>

                {/* Price */}
                <div>
                  {selectedOffer.onSale && selectedOffer.salePrice !== undefined ? (
                    <div className="flex items-baseline gap-3 flex-wrap">
                      <span className="text-4xl font-bold text-red-600">
                        {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[selectedOffer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || selectedOffer.currency}
                        {selectedOffer.salePrice.toLocaleString()}
                      </span>
                      <span className="text-2xl text-gray-400 line-through">
                        {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[selectedOffer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || selectedOffer.currency}
                        {selectedOffer.price.toLocaleString()}
                      </span>
                      <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-semibold">
                        On Sale
                      </span>
                    </div>
                  ) : (
                    <span className="text-4xl font-bold text-gray-900">
                      {CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[selectedOffer.currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS] || selectedOffer.currency}
                      {selectedOffer.price.toLocaleString()}
                    </span>
                  )}
                </div>

                {/* Availability Status */}
                <div>
                  {selectedOffer.available ? (
                    <div className="flex items-center gap-2 text-green-600">
                      <Check className="h-5 w-5" />
                      <span className="font-medium">
                        {selectedOffer.quantity !== undefined && selectedOffer.quantity > 0
                          ? `${selectedOffer.quantity} in stock`
                          : 'Available'}
                      </span>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2 text-red-600">
                      <X className="h-5 w-5" />
                      <span className="font-medium">Out of Stock</span>
                    </div>
                  )}
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 pt-2">
                  <div className="flex-1">
                    <PrimaryButton
                      text={
                        <span className="flex items-center justify-center gap-2">
                          <ShoppingBag className="h-5 w-5" />
                          <span>Buy Now</span>
                        </span>
                      }
                      fn={() => {
                        // TODO: Implement buy functionality
                        console.log('Buy clicked for:', selectedOffer.name);
                      }}
                      isDisabled={!selectedOffer.available}
                    />
                  </div>
                  {showBookAppointmentButton && (
                    <div className="flex-1">
                      <SecondaryButton
                        text={
                          <span className="flex items-center justify-center gap-2">
                            <Calendar className="h-5 w-5" />
                            <span>Book Appointment</span>
                          </span>
                        }
                        fn={() => {
                          navigate('/bookings/agnieszkaswiatly');
                        }}
                      />
                    </div>
                  )}
                </div>

                {/* Description */}
                {selectedOffer.description && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-3">Description</h2>
                    <p className="text-gray-600 leading-relaxed">{selectedOffer.description}</p>
                  </div>
                )}

                {/* Product Attributes */}
                <div className="border-t border-gray-200 pt-6 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Gown Type</p>
                      <p className="font-medium text-gray-900">{getGownTypeLabel(selectedOffer.gownType)}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500 mb-1">Style</p>
                      <p className="font-medium text-gray-900">{getGownStyleLabel(selectedOffer.gownStyle)}</p>
                    </div>
                    {selectedOffer.gownColor && (
                      <div>
                        <p className="text-sm text-gray-500 mb-1">Color</p>
                        <p className="font-medium text-gray-900">{getGownColorLabel(selectedOffer.gownColor)}</p>
                      </div>
                    )}
                    {selectedOffer.size && (
                      <div>
                        <p className="text-sm text-gray-500 mb-1">Size</p>
                        <p className="font-medium text-gray-900">{selectedOffer.size}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Additional Details */}
                {(selectedOffer.labelSize || selectedOffer.year) && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Additional Details</h2>
                    <div className="grid grid-cols-2 gap-4">
                      {selectedOffer.labelSize && (
                        <div>
                          <p className="text-sm text-gray-500 mb-1">Label Size</p>
                          <p className="font-medium text-gray-900">{selectedOffer.labelSize}</p>
                        </div>
                      )}
                      {selectedOffer.year && (
                        <div>
                          <p className="text-sm text-gray-500 mb-1">Year</p>
                          <p className="font-medium text-gray-900">{selectedOffer.year}</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Dress Features */}
                {selectedOffer.dressFeatures && Object.values(selectedOffer.dressFeatures).some(Boolean) && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Dress Features</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {selectedOffer.dressFeatures.fitAndFlare && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Fit and Flare</span>
                        </div>
                      )}
                      {selectedOffer.dressFeatures.sweetheart && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Sweetheart Neckline</span>
                        </div>
                      )}
                      {selectedOffer.dressFeatures.lowBack && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Low Back</span>
                        </div>
                      )}
                      {selectedOffer.dressFeatures.strapless && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Strapless</span>
                        </div>
                      )}
                      {selectedOffer.dressFeatures.floorLength && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Floor Length</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Special Features */}
                {selectedOffer.specialFeatures && selectedOffer.specialFeatures.length > 0 && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Special Features</h2>
                    <ul className="space-y-2">
                      {selectedOffer.specialFeatures.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Condition & Care */}
                {selectedOffer.condition && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-4">Condition & Care</h2>
                    <div className="space-y-3">
                      {selectedOffer.condition.isNew && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>New</span>
                        </div>
                      )}
                      {selectedOffer.condition.dryCleaned && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
                          <span>Dry Cleaned</span>
                        </div>
                      )}
                      {selectedOffer.condition.hasFlaws && (
                        <div className="flex items-center gap-2 text-sm text-amber-600">
                          <Info className="h-4 w-4 flex-shrink-0" />
                          <span>Has Flaws</span>
                        </div>
                      )}
                      {selectedOffer.condition.hasBeenAltered && (
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <Info className="h-4 w-4 flex-shrink-0" />
                          <span>Has Been Altered</span>
                        </div>
                      )}
                      {selectedOffer.condition.fabricType && (
                        <div className="text-sm text-gray-600">
                          <span className="font-medium">Fabric:</span> {selectedOffer.condition.fabricType}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Shipping Information */}
                <div className="border-t border-gray-200 pt-6">
                  <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                    <Truck className="h-5 w-5 text-primary-600" />
                    <span>Shipping Information</span>
                  </h2>
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-sm font-semibold text-gray-700 mb-2">National Shipping</h3>
                      <ul className="space-y-2 text-sm text-gray-600">
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Standard shipping: 5-7 business days</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Express shipping: 2-3 business days (available at checkout)</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Free shipping on orders over €500</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Carefully packaged and insured</span>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-gray-700 mb-2">International Shipping</h3>
                      <ul className="space-y-2 text-sm text-gray-600">
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>International shipping: 10-14 business days</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Shipping costs calculated at checkout</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Info className="h-4 w-4 text-amber-600 flex-shrink-0 mt-0.5" />
                          <span>Customs duties and taxes may apply (customer responsibility)</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
                          <span>Fully insured and tracked</span>
                        </li>
                      </ul>
                    </div>
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                      <p className="text-sm text-blue-800">
                        <strong>Note:</strong> All items are carefully packaged and shipped with tracking. You will receive a tracking number once your order ships.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Seller Information */}
                {(selectedOffer.sellerName || selectedOffer.sellerLocation) && (
                  <div className="border-t border-gray-200 pt-6">
                    <h2 className="text-lg font-semibold text-gray-900 mb-3">Seller Information</h2>
                    <div className="space-y-1 text-sm text-gray-600">
                      {selectedOffer.sellerName && <p className="font-medium">{selectedOffer.sellerName}</p>}
                      {selectedOffer.sellerLocation && <p>{selectedOffer.sellerLocation}</p>}
                      {selectedOffer.sellerType && (
                        <p className="text-xs text-gray-500 capitalize">{selectedOffer.sellerType}</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicStorePage;

